import { buildStyledComponent } from 'decisiv-ui-utils';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Container } from 'styled-components-reactive-grid';

import List from './List';
import ListElement from './ListElement';

/* istanbul ignore next */
const styles = ({ theme }) => `
  width: 100%;
  overflow-y: scroll;
  border-bottom: 1px solid ${theme.colors.base.chrome200};
`;

const themePropTypes = {
  colors: PropTypes.shape({
    base: PropTypes.shape({
      chrome200: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const ScrollableContainer = buildStyledComponent(
  'ScrollableContainer',
  styled(Container),
  styles,
  { themePropTypes },
);

ScrollableContainer.List = List;
ScrollableContainer.ListElement = ListElement;

export default ScrollableContainer;



// WEBPACK FOOTER //
// ./elements/ScrollableContainer/index.js